import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const reviews = [{
  name: 'Andrea M.',
  text: 'La atención al detalle de Laura es increíble. Mis uñas nunca se habían visto tan elegantes y saludables. El ambiente del estudio es puro relax.'
}, {
  name: 'Camila R.',
  text: 'El mejor servicio de Soft Gel que he probado. Llevo semanas con ellas intactas y el diseño es exactamente lo que pedí. 100% recomendada.'
}, {
  name: 'Sofía L.',
  text: 'Desde que entras sientes la exclusividad. Los productos son de primera y Laura te asesora perfecto sobre lo que mejor le va a tus manos.'
}];
export const Testimonials = () => {
  return <section className="py-24 md:py-32 px-6 md:px-12 max-w-7xl mx-auto" data-id="element-198">
      <div className="text-center mb-16 md:mb-24" data-id="element-199">
        <span className="font-sans text-xs tracking-[0.2em] uppercase text-brand-charcoal/60 mb-4 block" data-id="element-200">
          Experiencias
        </span>
        <h2 className="font-serif text-5xl md:text-6xl text-brand-charcoal" data-id="element-201">
          Sus reseñas
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-202">
        {reviews.map((review, index) => <motion.div key={review.name} initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: index * 0.15
      }} className="glass-panel rounded-3xl p-8 md:p-10 flex flex-col" data-id="element-203">
            <div className="flex gap-1 mb-6" data-id="element-204">
              {[...Array(5)].map((_, i) => <Star key={i} size={16} className="text-brand-charcoal fill-brand-charcoal" data-id="element-205" />)}
            </div>
            <p className="font-sans font-light text-brand-charcoal/80 leading-relaxed mb-8 flex-grow text-lg" data-id="element-206">
              "{review.text}"
            </p>
            <span className="font-serif italic text-xl text-brand-charcoal" data-id="element-207">
              — {review.name}
            </span>
          </motion.div>)}
      </div>
    </section>;
};